import { render, staticRenderFns } from "./qushi.vue?vue&type=template&id=3c21bf48&scoped=true&"
import script from "./qushi.vue?vue&type=script&lang=ts&"
export * from "./qushi.vue?vue&type=script&lang=ts&"
import style0 from "./qushi.vue?vue&type=style&index=0&id=3c21bf48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21bf48",
  null
  
)

export default component.exports